import { Field, Float, ID, InputType, ObjectType } from 'type-graphql'
import { Prop } from '@typegoose/typegoose'
import { generateEntityId } from '../generateEntityId'

@ObjectType()
@InputType('ShippingRateInput')
export class ShippingRate {
  @Field(() => ID)
  @Prop({ type: String, required: true, default: () => generateEntityId('srat') })
  _id: string

  @Field(() => Float)
  @Prop({ type: Number })
  shippingAmount: number

  @Field(() => Float)
  @Prop({ type: Number })
  shippingCost: number

  @Field(() => Float)
  @Prop({ type: Number })
  insuranceCost: number

  @Field(() => Float)
  @Prop({ type: Number })
  confirmationCost: number

  @Field(() => Float)
  @Prop({ type: Number })
  otherCost: number

  @Field(() => Float)
  @Prop({ type: Number })
  markupCost: number

  @Field(() => Float)
  @Prop({ type: Number })
  deliveryDays: number

  @Field(() => Date)
  @Prop({ type: Date })
  estimatedDeliveryDate: Date

  @Field(() => Date)
  @Prop({ type: Date })
  shipDate: Date

  @Field(() => String)
  @Prop({ type: String })
  serviceType: string

  @Field(() => String)
  @Prop({ type: String })
  serviceCode: string

  @Field(() => String)
  @Prop({ type: String })
  carrierName: string

  @Field(() => String)
  @Prop({ type: String })
  carrierId: string
}
